module.exports = __webpack_public_path__ + "static/media/28-3.40b7204b.mp3";